import moment from "moment";

export const state = {
  careReportfilters: {
    toDate: moment().format('YYYY-MM-DD'),
    fromDate: moment().startOf('month').format('YYYY-MM-DD')
  }
}
